import ForwardCallDisplay from './SendEmailDisplay'
import SendEmail from './SendEmailForm.container'
import IconEmail from 'components/Icons/Email'

export default {
  id: 'send_email',
  label: 'Send Email',
  helpUrl: 'https://help.thinkpickle.com.au/flows/actions/send-email',
  icon: IconEmail,
  inputs: [{}],
  outputs: [{}],
  display: ForwardCallDisplay,
  form: SendEmail,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SendEmail/index.js